// Generated by Melange

import * as Buhta_platformapis__Buhta_idp_v1_identity_tenant from "./buhta_idp_v1_identity_tenant.js";
import * as Buhta_platformapis__Buhta_idp_v1_profile from "./buhta_idp_v1_profile.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity.ml",
      79,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Identity"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Idp"
        ]]
    });

const Idp = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity.ml",
      117,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Identity"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity.ml",
      153,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Identity"
        ]]
    });

const Identity = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity.ml",
      187,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.idp.v1alpha1.Identity";
}

function make(idOpt, schemaOpt, profile, create_time, tenantsOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const schema = schemaOpt !== undefined ? schemaOpt : "";
  const tenants = tenantsOpt !== undefined ? tenantsOpt : /* [] */0;
  return {
          id: id,
          schema: schema,
          profile: profile,
          create_time: create_time,
          tenants: tenants
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_schema = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "schema",
            "schema"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile;

const merge_profile = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "profile",
            "profile"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            10,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Buhta_platformapis__Buhta_idp_v1_identity_tenant.Buhta.Idp.V1.IdentityTenant;

const merge_tenants = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            11,
            "tenants",
            "tenants"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          schema: Curry._2(merge_schema, t1.schema, t2.schema),
          profile: Curry._2(merge_profile, t1.profile, t2.profile),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
          tenants: Curry._2(merge_tenants, t1.tenants, t2.tenants)
        };
}

function spec(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Buhta_platformapis__Buhta_idp_v1_identity_tenant.Buhta.Idp.V1.IdentityTenant;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "schema",
                        "schema"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "profile",
                            "profile"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                10,
                                "create_time",
                                "createTime"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                    name: $$let$1.name,
                                    make: $$let$1.make,
                                    from_proto: $$let$1.from_proto,
                                    from_proto_exn: $$let$1.from_proto_exn,
                                    to_proto: $$let$1.to_proto,
                                    to_proto$p: $$let$1.to_proto$p,
                                    merge: $$let$1.merge,
                                    to_json: $$let$1.to_json,
                                    from_json_exn: $$let$1.from_json_exn,
                                    from_json: $$let$1.from_json
                                  })
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                  [
                                    11,
                                    "tenants",
                                    "tenants"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let$2.name,
                                        make: $$let$2.make,
                                        from_proto: $$let$2.from_proto,
                                        from_proto_exn: $$let$2.from_proto_exn,
                                        to_proto: $$let$2.to_proto,
                                        to_proto$p: $$let$2.to_proto$p,
                                        merge: $$let$2.merge,
                                        to_json: $$let$2.to_json,
                                        from_json_exn: $$let$2.from_json_exn,
                                        from_json: $$let$2.from_json
                                      }),
                                  Ocaml_protoc_plugin__Spec.not_packed
                                ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._6(serialize, writer, param.id, param.schema, param.profile, param.create_time, param.tenants);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, schema, profile, create_time, tenants) {
  return {
          id: id,
          schema: schema,
          profile: profile,
          create_time: create_time,
          tenants: tenants
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.Identity", spec(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.id, param.schema, param.profile, param.create_time, param.tenants);
  };
}

function constructor$1(id, schema, profile, create_time, tenants) {
  return {
          id: id,
          schema: schema,
          profile: profile,
          create_time: create_time,
          tenants: tenants
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.Identity", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Identity, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Identity"
        ]]
    }, V1alpha1, {
      Identity: Identity
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Identity"
              ]]
          },
          "V1alpha1"
        ]]
    }, Idp, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Identity"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Idp"
        ]]
    }, Buhta, {
      Idp: Idp
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
